import { render, staticRenderFns } from "./authManage.vue?vue&type=template&id=1b2270de"
import script from "./authManage.vue?vue&type=script&lang=js"
export * from "./authManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b2270de')) {
      api.createRecord('1b2270de', component.options)
    } else {
      api.reload('1b2270de', component.options)
    }
    module.hot.accept("./authManage.vue?vue&type=template&id=1b2270de", function () {
      api.rerender('1b2270de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/auth/authManage.vue"
export default component.exports